import request from "../../../Helpers/API";

export const GetASD = (usuariodefault) => {
  return request.get(`FUtiliti/GetAdrSucursalDepartamento?defaultuser=${1}`);
};

export const GetASDCXC = (usuariodefault) => {
  return request.get(`FUtiliti/GetAdrSucursalDepartamentoCXC?defaultuser=${1}`);
};

export const GetASDCXC2 = (usuariodefault) => {
  return request.get(`FUtiliti/GetAdrSucursalDepartamentoCXC2?defaultuser=${1}`);
};

export const GetEscenarios = () => {
  return request.get(`FEstadoResultados/FiltroEscenariosER`);
};

export const GetASDPostventas = () => {
  return request.get(`MensajeriaGeneral/FiltroSucursales`);
};
export const GetASDDashPostventas = () => {
  return request.get(`DashboardPostventa/FiltroSucursalesDash`);
};
export const GroupByPropCheck = (miArray, elements = [], checked = true) => {
  if (miArray === undefined || miArray.lenght === 0) return [];
  var array = miArray.reduce(function (groups, item) {
    var val = item[elements[0]];
    var newobject = {};

    elements.forEach((element) => {
      Object.defineProperty(newobject, element, {
        value: item[element],
        writable: true,
        enumerable: true,
        configurable: true,
      });
    });
    Object.defineProperty(newobject, "checked", {
      value: checked,
      writable: true,
      enumerable: true,
      configurable: true,
    });
    groups[val] = groups[val] || newobject;
    return groups;
  }, {});
  return Object.values(array);
};
export const GroupByProps = (miArray, elements = []) => {
  if (miArray === undefined || miArray.lenght === 0) return [];
  var array = miArray.reduce(function (groups, item) {
    var val = item[elements[0]];
    var newobject = {};

    elements.forEach((element) => {
      Object.defineProperty(newobject, element, {
        value: item[element],
        writable: true,
        enumerable: true,
        configurable: true,
      });
    });

    groups[val] = groups[val] || newobject;
    return groups;
  }, {});
  return Object.values(array);
};
export const GroupByForeignKey = (
  miArray,
  foreignkey,
  keyvalue,
  elements = [],
  checked = false
) => {
  if (miArray === undefined || miArray.lenght === 0) return [];
  var newarray = miArray.filter((item) => item[foreignkey] == keyvalue);
  if (newarray === null || newarray.lenght === 0) return [];
  var array = newarray.reduce(function (groups, item) {
    var val = item[elements[0]];
    var newobject = {};

    elements.forEach((element) => {
      Object.defineProperty(newobject, element, {
        value: item[element],
        writable: true,
        enumerable: true,
        configurable: true,
      });
    });
    Object.defineProperty(newobject, "checked", {
      value: checked,
      writable: true,
      enumerable: true,
      configurable: true,
    });
    groups[val] = groups[val] || newobject;
    return groups;
  }, {});
  return Object.values(array);
};

export const GetPeriodo = (mesinicio, mesfin) => {
  if (mesinicio == 0 && mesfin == 0) return 0;
  if (mesinicio == 0 && Number(mesfin) > 0) return mesfin;
  if (mesfin == 0 && Number(mesinicio) > 0) return mesinicio;
  var datain = mesinicio;
  for (let x = Number(mesinicio) + 1; x <= Number(mesfin); x++) {
    datain = datain + "," + x;
  }
  return datain.toString();
};

export const GetKey = (data, prop) => {
  if (data == undefined || data == null || data.length == 0) return "";
  var datain = "";
  data.forEach((item) => {
    datain = datain + item[prop] + ",";
  });
  if (datain == "") return "";
  return datain.substring(0, datain.length - 1);
};


export const GetGastosvsProyeccionAction = (
  ejercicio,
  tipo,
  mesinicio,
  mesfin,
  adr,
  sucursal,
  departamento
) => {
  if (ejercicio == 0) {
    return new Promise((res, req) => req("Favor de indicar el ejercicio"));
  }
  if (mesinicio == 0) {
    return new Promise((res, req) => req("Favor de indicar el mes"));
  }
  if (tipo == 0) {
    return new Promise((res, req) => req("Favor de indicar el tipo de gasto"));
  }
  const post = {
    ejercicio,
    periodo: GetPeriodo(mesinicio, mesfin),
    adr: GetKey(adr, ["idadr"]),
    sucursal: GetKey(sucursal, ["idsucursal"]),
    departamento: GetKey(departamento, ["iddepartamento"]),
    tipo,
  };

  return request.post("Gastos/GastosvsProyeccionbyTiempo", post);
};